import { useState } from "react";

import Modal from "../Modal";

/* import buscarConcesionarioPorSeriePlacas from "../../helpers/concesionario/buscarConcesionarioPorSeriePlacas";
import buscarConcesionarioPorIdConcesion from "../../helpers/concesionario/buscarConcesionarioPorIdConcesion"; */
import mensajePreventivo from "../../helpers/mensajes/mensajePreventivo";

import VerificarUsuario from "../../helpers/usuario/verificarUsuario";
import obtener from "../../helpers/contribuyente/contribuyente/obtener";
import obtenerPorPlacas from "../../helpers/contribuyente/contribuyente/obtenerPorPlacas";
import obtenerPorIdConcesion from "../../helpers/contribuyente/contribuyente/obtenerPorIdConcesion";
import Lista from "./Lista";

/**
 * Componente padre de concesiones, con hijos: ConcesionesLista
 * @param {Object} param0 
 * @returns Componente React
 */
export default function Concesiones({ data, setData, catalogos, checked, setChecked }) {

    /* console.clear(); */
    VerificarUsuario();
    const { contribuyente, concesionActual } = data;
    const [isModalOpen, setModalIsOpen] = useState(false);
    const [contribuyentes, setContribuyentes] = useState([]);

    const toggleModal = () => setModalIsOpen(!isModalOpen);

    if (data.concesiones !== undefined) if (data.concesiones.length === 0) mensajePreventivo("Sin concesiones aún", 1000);

    return (
        <div className="contenedorMain">
            <div className="formulario">
                <div className="boxRow">
                    {/* Nombre del contribuyente*/}
                    <div className="boxColumn flex3">
                        <label className="lblCampo" id="lblContribuyente">Contribuyente</label>
                        <div className="search-bar" onKeyDown={e => e.key === "Enter" && obtener(contribuyente, setData, setContribuyentes, setModalIsOpen)}>
                            {/* Nombre */}
                            <input className="actions" id="inputNombre" type="text" placeholder="Nombre(s)"
                                value={contribuyente?.nombre === undefined ? "" : contribuyente?.nombre.toUpperCase()}
                                onChange={e => setData({ ...data, contribuyente: { ...contribuyente, nombre: e.target.value.toUpperCase() } })}
                            />

                            {/* Apellido paterno*/}
                            {!contribuyente?.tipoPersona && (
                                <input className="actions" id="inputApellidoP" type="text" placeholder="Apellido Paterno"/*  */
                                    value={contribuyente?.apellidoPaterno === undefined ? "" : contribuyente?.apellidoPaterno.toUpperCase()}
                                    onChange={e => setData({ ...data, contribuyente: { ...contribuyente, apellidoPaterno: e.target.value.toUpperCase() } })}
                                />
                            )}

                            {/* Apellido materno */}
                            {!contribuyente?.tipoPersona && (
                                <input className="actions" id="inputApellidoM" type="text" placeholder="Apellido Materno"
                                    value={contribuyente?.apellidoMaterno === undefined ? "" : contribuyente?.apellidoMaterno.toUpperCase()}
                                    onChange={e => setData({ ...data, contribuyente: { ...contribuyente, apellidoMaterno: e.target.value.toUpperCase() } })}
                                />
                            )}

                            {/* Buscar */}
                            <div className="actions">
                                <button onClick={() => obtener(contribuyente, setData, setContribuyentes, setModalIsOpen)}>
                                    <span className="material-symbols-outlined">
                                        search
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* RFC */}
                    <div className="boxColumn">
                        <label className="lblCampo" >RFC</label>
                        <div className="search-bar" onKeyDown={e => e.key === "Enter" && obtener(contribuyente, setData, setContribuyentes, setModalIsOpen)}>
                            <input className="actions" type="text"
                                value={contribuyente?.rfc === undefined ? "" : contribuyente?.rfc.toUpperCase()}
                                onChange={e => setData({ ...data, contribuyente: { ...contribuyente, rfc: e.target.value.toUpperCase() } })}
                            />
                            <div className="actions" onClick={() => obtener(contribuyente, setData, setContribuyentes, setModalIsOpen)}>
                                <button><span className="material-symbols-outlined">
                                    search
                                </span></button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="boxRow">
                    {/* Número de placas */}
                    <div className="boxColumn">
                        <label className="lblCampo" >No. Placas</label>
                        <div className="search-bar" onKeyDown={e => e.key === "Enter" && obtenerPorPlacas(data, setData)}>
                            <input className="actions" type="text"
                                value={concesionActual?.seriePlaca === undefined ? "" : concesionActual?.seriePlaca.toUpperCase()}
                                onChange={e => setData({ ...data, concesionActual: { ...concesionActual, seriePlaca: e.target.value.toUpperCase() } })}
                            />
                            <div className="actions" onClick={() => obtenerPorPlacas(data, setData)}>
                                <button><span className="material-symbols-outlined">
                                    search
                                </span></button>
                            </div>
                        </div>
                    </div>

                    {/* Número de concesión */}
                    <div className="boxColumn">
                        <label className="lblCampo" >Concesión</label>
                        <div className="search-bar" onKeyDown={e => e.key === "Enter" && obtenerPorIdConcesion(data, setData)}>
                            <input className="actions" type="text"
                                value={concesionActual?.idConcesion === undefined ? "" : concesionActual?.idConcesion}
                                onChange={e => setData({ ...data, concesionActual: { ...concesionActual, idConcesion: e.target.value.toUpperCase() } })}
                            />
                            <div className="actions" onClick={() => obtenerPorIdConcesion(data, setData)}>
                                <button><span className="material-symbols-outlined">
                                    search
                                </span></button>
                            </div>
                        </div>
                    </div>

                    {/* Años de concesión */}
                    <div className="boxColumn">
                        <label className="lblCampo" >Años Concesión</label>
                        <div className="search-bar-lbl">
                            <input type="text" placeholder="##" value={`${concesionActual?.vigenciaAnios ?? ""}`} disabled />
                        </div>
                    </div>

                    {/* Fecha de vencimiento */}
                    <div className="boxColumn">
                        <label className="lblCampo" >Fecha Vencimiento</label>
                        <div className="search-bar-lbl">
                            <input type="text" placeholder="dd / mm / aa" disabled
                                value={concesionActual?.fechaVencimiento ?? ""}
                            />
                        </div>
                    </div>
                </div>

                {/* Observaciones */}
                <div className="boxRow">
                    <div className="boxColumn">
                        <label className="lblCampo" >Observaciones</label>
                        <div className="search-bar-textarea">
                            <textarea name="textarea" rows="3" cols="1"
                                value={concesionActual?.observaciones === undefined ? "" : concesionActual?.observaciones.toUpperCase()}
                                onChange={e => setData({ ...data, concesionActual: { ...concesionActual, observaciones: e.target.value.toUpperCase() } })}
                            >
                            </textarea>
                        </div>
                    </div>
                </div>
            </div>

            <div className="boxRow divider"> <div></div> </div>

            {/* Modal */}
            {isModalOpen && <Modal onRequestClose={toggleModal} contribuyentes={contribuyentes} setData={setData} />}


            {/* Lista de concesiones */}
            <Lista
                data={data}
                checked={checked}
                setData={setData}
                catalogos={catalogos}
                setChecked={setChecked}
            />

        </div>
    );
}
